import { useSocialCoachSession, useSocialSettings } from "@/utils";
import React, { useMemo } from "react";
import { PlayerAccount, SocialNetworksId } from "@/interfaces";
import { SocialProfileCard } from "@/components/SocialNetworkProfiles/components";

interface Props {
  player?: PlayerAccount;
  networkFilter?: SocialNetworksId[];
  onConnected?: (networkId: SocialNetworksId) => void;
}

export function SocialNetworkProfiles({ player, networkFilter, onConnected }: Props) {
  const { userId: sessionUserId } = useSocialCoachSession();
  const effectiveUserId = player?.userId || sessionUserId;

  const { allowedNetworkIds } = useSocialSettings(player?.playerId);

  const supportedNetworks: SocialNetworksId[] = ["FB", "IG", "LI", "TT", "TW", "GL", "ZL"];

  const displayedNetworks = useMemo(() => {
    const safeNetworks = allowedNetworkIds || [];
    let networks = supportedNetworks.filter(n => safeNetworks.includes(n));

    if (networkFilter) {
      networks = networks.filter(n => networkFilter.includes(n));
    }

    return networks;
  }, [allowedNetworkIds, networkFilter]);

  return (
    <div className="w-full flex flex-col gap-6 max-w-5xl">
      {/* Grid Container for Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
        {effectiveUserId &&
          displayedNetworks.map(networkId => (
            <SocialProfileCard
              key={`social-profile-card-${networkId}`}
              userId={effectiveUserId}
              networkId={networkId}
              onConnected={onConnected}
            />
          ))}
      </div>
    </div>
  );
}
